module.exports = __webpack_public_path__ + "img/logo.e75ced23.png";